import { render, staticRenderFns } from "./BusDocuments.vue?vue&type=template&id=ee633c68&scoped=true&"
import script from "./BusDocuments.vue?vue&type=script&lang=js&"
export * from "./BusDocuments.vue?vue&type=script&lang=js&"
import style0 from "./BusDocuments.vue?vue&type=style&index=0&id=ee633c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee633c68",
  null
  
)

export default component.exports